import React from 'react'
import LeftBar from '../Components/LeftBar'
import Dashnav from '../Components/Dashnav'
import EmailComp from './EmailComp'

function TheEmails() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <EmailComp/>      
        </div>
    </div>
  )
}

export default TheEmails